import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../components/FormComponents/styles.scss';

import getCompanyOptionData from '../helper/getCompanyOptionData';

const CompanyOption = ({ innerRef, innerProps, data: { company }, isSelected, isFocused }) => {
  const { t } = useTranslation('account');

  let className = 'company-option-wrapper';
  if (isSelected) {
    className += ' selected';
  }
  if (isFocused) {
    className += ' focused';
  }

  const { name, address } = getCompanyOptionData(company, t);

  return (
    <div className={className} ref={innerRef} {...innerProps} isSelected={isSelected} isFocused={isFocused}>
      <div style={{ fontSize: 16, fontWeight: 'bold' }}>{name}</div>
      <div>{address}</div>
    </div>
  );
};

export default CompanyOption;
